import {
  useEffect,
  useRef,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  Box,
  Center,
  Grid,
  GridItem,
  Image,
  Skeleton,
  Stack
} from '@chakra-ui/react'
import { DownArrowIcon } from 'assets/icons'
import {
  getNotificationMessage,
  setUserSectionPage,
  usersSelectors
} from 'store'
import { REJECTED } from 'utils/constants'

export const SocialProfileSelect = ({
  setSocialLinkSelected,
  socialLinksArray
}) => {
  const [isHeightLonger, setIsHeightLonger] = useState(false)
  const [loadedSocialLinkImage, setLoadedSocialLinkImage] = useState({})

  const handleSocialLinkImage = (socialLinkId) => {
    setLoadedSocialLinkImage((prev) => ({
      ...prev,
      [socialLinkId]: true
    }))
  }

  const socialProfileSelectRef = useRef(null)
  const dispatch = useDispatch()

  const {
    searchSocialLinks,
    searchSocialLinksCategories
  } = useSelector(usersSelectors)

  const handleSelectSocialProfile = (e) => {
    if (socialLinksArray.map((item) => item.id).includes(e.id)) {
      dispatch(
        getNotificationMessage({
          type: REJECTED,
          message: 'You have already chosen that platform',
          isEditProfile: true
        })
      )
    } else {
      setSocialLinkSelected(e)
      dispatch(setUserSectionPage(null))
    }
  }

  useEffect(() => {
    const el = socialProfileSelectRef.current
    if (!el) return undefined

    const checkScroll = () => {
      const isOverflowing = el.scrollHeight > el.clientHeight
      const isAtBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 1

      setIsHeightLonger(isOverflowing && !isAtBottom)
    }

    checkScroll()
    el.addEventListener('scroll', checkScroll)

    return () => {
      el.removeEventListener('scroll', checkScroll)
    }
  }, [])

  return (
    <>
      <Stack
        position="absolute"
        bgColor="#F6D318"
        width="100%"
        height="100%"
        top={0}
        left={0}
        zIndex={3}
        ref={socialProfileSelectRef}
        overflowY="scroll"
        direction="column"
        sx={{
          '::MsOverflowStyle': 'none',
          scrollbarWidth: 'none',
          '::-webkit-scrollbar': {
            display: 'none'
          }
        }}
      >
        {/* Social Links Icons */}
        <Stack
          zIndex={1}
          marginTop="20px !important"
          width="100%"
          alignItems="center"
          spacing="10px 10px 0px 10px"
        >
          {
            searchSocialLinksCategories.filter((item) => item.socialLinksCount > 0)
              .map((item) => ((
                <Stack
                  key={item?.id}
                  paddingLeft="20px"
                  width="inherit"
                >
                  <Box
                    key={item.id}
                    height=""
                    width="95%"
                    bgGradient="linear(to-b, #fff, #F4E69B)"
                    borderRadius="5px"
                    data-name={item.name}
                  >
                    <Grid
                      w="100%"
                      templateColumns="repeat(2, 1fr)"
                      gap="70px"
                      padding="70px 18.5% 70px 18.5%"
                      sx={{
                        '@media (max-width: 480px)': {
                          padding: '40px 14% 50px 14%',
                          gap: '40px'
                        }
                      }}
                    >
                      {
                        searchSocialLinks.map((items) => (
                          items.idCategory === item.id && (
                            <GridItem
                              as="button"
                              key={items.id}
                              w="100px"
                              h="100px"
                              borderRadius="20px"
                              alignItems="center"
                              onClick={() => handleSelectSocialProfile(items)}
                            >
                              <Center h="100px">
                                <Skeleton
                                  isLoaded={loadedSocialLinkImage[items.id]}
                                  borderRadius="20px"
                                  w="100%"
                                  h="100%"
                                >
                                  <Image
                                    src={items.icon}
                                    borderRadius="20px"
                                    w="100%"
                                    h="100%"
                                    data-name={items.name}
                                    data-title="socialLink"
                                    onLoad={() => handleSocialLinkImage(items.id)}
                                  />
                                </Skeleton>
                              </Center>
                            </GridItem>
                          )
                        ))
                      }
                    </Grid>
                  </Box>
                  <Box width="100%" h="15px" bgColor="#f6d318" />
                </Stack>
              )))
          }
        </Stack>
      </Stack>

      {
        isHeightLonger === true && (
          <Stack
            id="eeeeee"
            w="100%"
            alignItems="center"
            position="absolute"
            bottom={2}
            left={0}
            zIndex={3}
          >
            <DownArrowIcon />
          </Stack>
        )
      }
    </>
  )
}
